<template>

    <div class="main-progress-bar" v-show="show_progress_bar">

        <v-progress-circular
                class="control-progress-bar"
                indeterminate
                :size="150"
                :width="6"
                :color="color_progress_bar"
        ></v-progress-circular>

    </div>

</template>

<script>
    export default {
        name: "ProgressBar",
        props: {
            show_progress_bar: {
                type: Boolean,
                default: false
            },
            color_progress_bar: {
                type: String
            }
        }
    };
</script>

<style lang="scss">
    .main-progress-bar {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 999;

        .control-progress-bar {
            position: fixed;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 15;
        }
    }
</style>
